import styled from 'styled-components';
import { Row, Column } from '@simplywallst/ui-core';
import { MoreHorizontalSolid } from '@simplywallst/ui-core/icons';

export const MoreIcon = styled(MoreHorizontalSolid)`
  opacity: 1 !important;
`;

export const Error = styled(Row)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  padding: ${({ theme }) => theme.x4spacePx}px;
  h2 {
    color: ${({ theme }) => theme.color.white};
  }
`;

export interface PrintWatermarkProps {
  canShowLogo?: boolean;
}
export const PrintModeWatermark = styled(Column)<PrintWatermarkProps>`
  display: none;
  position: fixed;
  bottom: 0;
  right: 0;
  color: ${({ theme }) => theme.color.white} !important;
  width: 100%;
  justify-content: ${({ canShowLogo }) =>
    canShowLogo ? 'space-between' : 'flex-end'};
  > svg {
    height: auto;
    width: 150px;
  }
  > img {
    height: auto;
    width: 150px;
  }
  padding: ${({ theme }) => theme.x4space}px;
`;

export const WatermarkCopy = styled('span')`
  font-size: ${({ theme }) => theme.x2spacePx}px;
`;

export const Logo = styled('div')<PrintWatermarkProps>`
  display: ${({ canShowLogo }) => (canShowLogo ? 'inline' : 'none')};
  img {
    height: 50px;
  }
`;
